import ChangePasswordCard from '../components/ChangePasswordCard';

export default function ChangePassword() {
  return (
    <div className="min-w-screen min-h-screen bg-[#F9F5F2]">
      <div className="w-full flex justify-center py-16 px-4">
        <ChangePasswordCard />
      </div>
    </div>
  );
}

